<template>
  <a class="panel-promo" :href="promo.url">
    <i :class="promo.icon"></i>
    <span class="excerpt">{{ promo.excerpt }}</span>
    <i class="far fa-arrow-right"></i>
  </a>
</template>
<script>
  export default {
    name: 'PanelPromo',
    props: {
      promo: Object,
    },
  }
</script>

<style lang="scss">
  .panel-promo { 
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all .4s;
    background: rgba(218,218,218,1);
    border: 0;
    padding: 10px 15px;

    svg:first-child {
      color: #fff;
      background: #0046ad;
      width: 40px;
      height: 40px;
      padding: 8px;
      border-radius: 50px;
    }

    .excerpt {
      padding: 0 15px 0 10px;
      color: #333;
    }

    .fa-arrow-right {
      color:#333;
      width: 20px;
      height: 22px;
    }
    
    &:hover {
      background: rgba(241,241,241,.8);
      cursor: pointer;

      svg:first-child,
      .fa-arrow-right {
        transition: all .4s;
        margin-left: 5px;
      }
    }
  }
</style>
